import React, { useState } from "react";
import {
    Package,
    FileText,
    Users,
    Menu,
    ClipboardList,
    Boxes,
    DownloadCloudIcon,
    Upload,
} from "lucide-react";
import { NavLink } from "react-router-dom";
import { useAuthStore } from '../../../store/useAuthStore';
import {
    canAccessStockUpload,
    isInventoryStockOnlyUser,
} from '../../../utils/permissions';


const Sidebar = ({ isOpen }) => {
    const [isSidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);
    const { user } = useAuthStore();
    const USER_ROLE = user?.userDataObj?.role;
    const showStockUpload = canAccessStockUpload(user);
    const inventoryStockOnly = isInventoryStockOnlyUser(user);

    const inventoryItem = { icon: <Package className="h-6 w-6" />, text: USER_ROLE === 4 ? "Inventory" : "Product Catalogue", url: "/" };
    const stockUploadItem = { icon: <Upload className="h-6 w-6" />, text: "Stock Upload", url: "/stock-upload" };

    let navItems;

    if (inventoryStockOnly) {
      // Permission 400: only Inventory + Stock Upload
      navItems = [
        inventoryItem,
        ...(showStockUpload ? [stockUploadItem] : []),
      ];
    } else if (USER_ROLE === 4) {
      navItems = [
        { icon: <FileText className="h-6 w-6" />, text: "Overview", url: "/order-list" },
        inventoryItem,
        { icon: <Users className="h-6 w-6" />, text: "Distributor", url: "/distributor-list" },
        { icon: <ClipboardList className="h-6 w-6" />, text: "Summary", url: "/summary-list" },
        { icon: <Boxes className="h-6 w-6" />, text: "Packer-Dispatcher", url: "/packer-dispatcher" },
        { icon: <DownloadCloudIcon className="h-6 w-6" />, text: "Download", url: "/download-list" },
        ...(showStockUpload ? [stockUploadItem] : []),
      ];
    } else {
      navItems = [
        inventoryItem,
        { icon: <FileText className="h-6 w-6" />, text: "Overview", url: "/order-list" },
        { icon: <ClipboardList className="h-6 w-6" />, text: "Summary", url: "/summary-list" },
        { icon: <DownloadCloudIcon className="h-6 w-6" />, text: "Download", url: "/download-list" },
        ...(showStockUpload ? [stockUploadItem] : []),
      ];
    }

    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen);
      };

    return (
        <>
            <div className={`min-h-screen fixed inset-y-0 left-0 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'
                } relative translate-x-0 transition-transform duration-300 ease-in-out block`}>
                <div className={`${isSidebarOpen ? 'w-52' : 'w-20'} h-full bg-emerald-600 transition-width duration-300 ease-in-out`}>
                    <div className="flex items-center h-10 px-3 pt-7 pb-5">
                        <span className="text-white text-xl font-bold">
                           <img src={isSidebarOpen ? '/bremskerl_Logo.png' : '/bremskerl_logo_mobile.png' } alt="Bremskerl" className={isSidebarOpen ? '':'max-w-12'} style={{transition: 'all 0.3s ease'}} />
                        </span>
                    </div>
                    <div className="px-2 py-2">
                        <div className="flex justify-between items-center px-2 text-white text-lg font-medium">
                            {isSidebarOpen && <p>Menu</p>}
                            <button
                            onClick={toggleSidebar}
                            className="p-2 rounded-md text-right text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-emerald-500 cursor-pointer"
                            >
                            <Menu size={24} />
                            </button>
                        </div>
                        <nav className="mt-3 flex-1 px-2 space-y-1">
                            {navItems.map((item, index) => (
                               <NavLink
                               key={index}
                               to={item.url}
                               className={({ isActive }) =>
                                 `group flex items-center py-1 text-sm leading-6 font-medium rounded-md ${
                                   isActive ? "text-white bg-emerald-700" : "text-emerald-100 hover:bg-emerald-700"
                                 }`
                               }
                             >
                               <a title={item.text} className="mr-4">{item.icon}</a>
                               {isSidebarOpen && item.text}
                             </NavLink>
                            ))}
                        </nav>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sidebar;
